<script setup>
  import UpgradeBlock from '@/components/UpgradeBlock.vue';

  const upgrade = [true, ['pro', 'gold'], true];
</script>

<template>
  <div
    class="jwx-data-container__content--centered"
    style="--max-height: 236px; height: 236px;"
  >
    <div class="jwx-data-container__blurred-content jwx-overflow-hidden">
      <p>
        If we get the expected inland valley clearing UP AND DOWN GUSTY NNW & N upper teens to low 20's winds develop outside.<br><br>
        <strong>Special Update Issued at</strong>: 2/5 01:46 PM 2 foilers out in about 12 knot winds and doing well. 5 kite rigged and waiting at Rasta Beach. Wind still patchy.<br><br>
      <strong>Special Update Issued at</strong>: 2/5 12:09 PM Not looking promising. The winds about a mile outside are in the upper teens range but very PATCHY. The swell hitting the beach has a very mixed period which means unstable and shifty winds to our north. Likewise the satellite imagery shows the earlier inbound hole in the clouds is now full of patchy clouds. There is a clear area near Todas Santos that may get here mid afternoon but overall conditions are very iffy for reliable wind at the beach.
      </p>
    </div>
    <UpgradeBlock productText="<strong>Pro Forecasts</strong>" :upgrade="upgrade" />
  </div>
</template>